// SF New Deal + HSA Combined Logo Component
export const SFNewDealLogo = ({ size = 'medium' }) => {
  const maxWidths = {
    small: 120,
    medium: 160,
    large: 200
  };

  return (
    <img
      src="/sfnd-hsa-combined-logo-white.png"
      alt="SF New Deal & HSA"
      style={{ maxWidth: maxWidths[size], height: 'auto' }}
    />
  );
};

// Restaurant Dashboard Logo — uses the STACKED SFND+HSA lockup (2.33:1) instead
// of the ultra-wide horizontal one (8:1). In the dashboard header the logo shares
// a row with the language picker + 3 action buttons; the wide lockup clipped the
// HSA half on phone widths, so we size the stacked mark by HEIGHT to fit the nav.
export const RestaurantLogo = ({ size = 'medium' }) => {
  const maxHeights = {
    small: 40,
    medium: 48,
    large: 64
  };

  return (
    <img
      src="/sfnd-hsa-stacked-logo.png"
      alt="SF New Deal & San Francisco Human Services Agency"
      // flexShrink:0 keeps the mark at its natural size next to the action buttons;
      // objectFit:contain is a safety net so it scales proportionally (never squishes)
      // if the row ever runs out of room on very narrow screens.
      style={{ height: maxHeights[size], width: 'auto', flexShrink: 0, objectFit: 'contain' }}
    />
  );
};
